import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepNameSchema = z.object({
    public_name: z
        .string()
        .trim()
        // @ts-ignore
        .min(1, i18n.t('name_required'))
        // @ts-ignore
        .max(100, i18n.t('name_too_long'))
        // @ts-ignore
        .regex(/^[^\p{Emoji}\p{Emoji_Component}]+$/u, i18n.t('emoji_not_allowed'))
        // @ts-ignore
        .regex(/^[\p{L}\s]+$/u, i18n.t('only_letters_and_spaces_are_allowed'))
        .refine((val) => val.trim().length > 0, {
            // @ts-ignore
            message: i18n.t('name_can_not_consist_only_of_spaces'),
        })
});

export type RegistrationStepNameType = z.infer<typeof registrationStepNameSchema>;
